<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-20 13:59:29
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-06-20 14:11:47
--> 
<template>
  <div class="pi-tabs">
    <div
      class="pi-tabs-flex"
      :class="active == item.value ? 'active' : ''"
      @click="tabsClick(item)"
      v-for="(item, index) in list"
      :key="index"
    >
      <div class="pi-tabs-name">{{ item.name }}</div>
      
    </div>
  </div>

  <!-- <div class="pi-tabs-border" v-if="type == 'border'">
    <div class="pi-tabs-item"
         @click="tabsClick(item)"
         v-for="(item,index) in list"
         :key="index">
      <div class="pi-tabs-name"  :class="{'active': item.value == active}">{{item.name}}</div>
    </div>
  </div>
  <div class="pi-tabs" v-else>
    <div class="pi-tabs-item"
         @click="tabsClick(item)"
         :class="{'active': item.value == active}"
         v-for="(item,index) in list"
         :key="index">
      <div class="pi-tabs-name">{{item.name}}</div>
    </div>
  </div> -->
</template>
<script>
export default {
  name: "pi-tabs",
  data() {
    return {};
  },
  methods: {
    tabsClick(item) {
      this.$emit("change", item);
    },
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    active: {
      type: String || Number,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="less">
.pi-tabs {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 0.27rem;
  background-color: #fff;
  height: 0.94rem;

  .pi-tabs-flex {
    flex: 1;
    text-align: center;
    
    .pi-tabs-name{
      display: inline-block;
      position: relative;
      padding: 0.23rem 0;
      font-size: 0.34rem;
      line-height: 0.48rem;
    }
  }
  .active {
    position: relative;
    color: #14cc80;
  }
  .active .pi-tabs-name:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 0.06rem;
    background-color: #14cc80;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
// .pi-tabs {
//   padding: 0.2rem 0;
//   display: flex;
//   .pi-tabs-item {
//     flex: 1;
//     text-align: center;
//     color: #999999;
//     cursor: pointer;
//     .pi-tabs-name {
//       display: inline-block;
//       padding: 0.02rem 0.14rem;
//       line-height: 0.33rem;
//       font-size: 0.24rem;
//     }
//   }
//   .pi-tabs-item.active {
//     .pi-tabs-name {
//       background: rgba(20, 204, 128, 0.24);
//       color: #14cc80;
//     }
//   }
// }
// .pi-tabs-border{
//   background-color: #fff;
//   display: flex;
//   .pi-tabs-item{
//     flex: 1;

//     text-align: center;
//     font-size: 0.34rem;
//     line-height: 0.48rem;
//     color: #666;
//   }
//   .pi-tabs-name{
//     padding: 0.23rem 0;
//     display: inline-block;
//     position: relative;
//   }
//   .pi-tabs-name.active{
//     color: #14cc80;
//   }
//   .pi-tabs-name.active:after{
//     content: '';
//     width: 1.3rem;
//     height: 0.06rem;
//     background-color: #14cc80;
//     left: 50%;
//     transform: translateX(-50%);
//     bottom: 0;
//     position: absolute;
//   }
// }
</style>